import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoadingModule } from 'src/app/shared/components';
import { AttendanceStatusPageComponent } from './attendance-status-page.component';
import { NgxMaskModule } from 'ngx-mask';
import { AddressPipeModule } from 'src/app/shared/pipes';

@NgModule({
    declarations: [
        AttendanceStatusPageComponent
    ],
    exports: [
        AttendanceStatusPageComponent,
    ],
    imports: [
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        LoadingModule,
        BrowserModule,
        ReactiveFormsModule,
        NgxMaskModule,
        AddressPipeModule
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AttendanceStatusPageModule { }
